import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import { DateTime } from "luxon";
import ProgramCard from "./ProgramCard";
import Filter from "./Filter";


function App() {
	const timeZone = 'America/Chicago'
	const [calendarData, setCalendarData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [requestedServiceCategory, setRequestedServiceCategory] = useState(0);
	const [view, setView] = useState("default");

	const brand_name = "Gorgeously Bungee Fitness";
	const gym_brand_id = 8;
	const gym_location_id = 8;
	const requested_staff_id = 38;
	const requested_timezone_id = 2;
	const redirect_url = "https://gorgeouslybungeefitness.com/schedule";
	const defaultServiceImage = "https://physio-images.s3.us-east-2.amazonaws.com/gym-images/67841737081804.png";
	const guestCheckoutUrl = "client";

	const [selectedDate, setSelectedDate] = useState(() => {
		const today = DateTime.now().setZone(timeZone);
		return today; // Store the DateTime object directly
	});

	const getWeekDates = (startDate) => {
		// Ensure startDate is a DateTime object
		const inputDate = DateTime.isDateTime(startDate)
			? startDate
			: DateTime.fromISO(startDate);

		// Find the start of the week (Sunday)
		const startOfWeek = inputDate.minus({ days: inputDate.weekday % 7 });

		// Generate an array of 7 dates for the week
		const weekDates = Array.from({ length: 7 }, (_, i) => {
			const currentDate = startOfWeek.plus({ days: i });
			return {
				day: currentDate.toFormat("cccc"), // Full weekday name
				date: currentDate.toFormat("MM/dd/yyyy"), // MM/DD/YYYY format
			};
		});

		return weekDates;
	};
	const weekDates = getWeekDates(selectedDate);

	useEffect(() => {
		let apiUrl = "";
		if (requestedServiceCategory == 3) {
			apiUrl = "https://eov9tfaim2.execute-api.us-east-2.amazonaws.com/gymweb/program/fetch_all_program";
			setView('program');
		} else if (requestedServiceCategory == 6) {
			apiUrl = "https://eov9tfaim2.execute-api.us-east-2.amazonaws.com/gymweb/package/fetch_package";
			setView('package');
		} else if (requestedServiceCategory == 5) {
			apiUrl = "https://eov9tfaim2.execute-api.us-east-2.amazonaws.com/gymweb/membership/fetch_all_membership";
			setView('membership');
		} else {
			apiUrl = "https://eov9tfaim2.execute-api.us-east-2.amazonaws.com/gymweb/gym-calender/fetch_gym_calendar"; // Default calendar API
			setView('default');
		}

		let payload = {};

		if (requestedServiceCategory == 6) {
			// For packages: Last 6 months to end of the current week
			const endDate = weekDates[6].date; // Current week's end date
			const sixMonthsAgo = selectedDate.minus({ months: 6 }).toFormat("MM/dd/yyyy");
	
			payload = {
				start_date: sixMonthsAgo,
				end_date: endDate,
				gym_brand_id,
				gym_location_id,
				requested_staff_id,
				requested_timezone_id
			};
		} else {
			// For others: Just the current week
			payload = {
				start_date: weekDates[0].date,
				end_date: weekDates[6].date,
				gym_brand_id,
				gym_location_id,
				requested_staff_id,
				requested_timezone_id
			};
		}

		fetchData(apiUrl, payload);

	}, [selectedDate, requestedServiceCategory]);

	const fetchData = (apiUrl, payload) => {
		setLoading(true)
		fetch(apiUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		})
			.then(response => {
				if (!response.ok) {
					throw new Error("Failed to fetch data");
				}
				return response.json();
			})
			.then(data => {
				let currentCalendarData = data.result;
				let filteredCalendarData = [];

				if (requestedServiceCategory == 1 || requestedServiceCategory == 2 || requestedServiceCategory == 4) {
					filteredCalendarData = currentCalendarData?.filter(service => service.service_category_id == requestedServiceCategory);
				} else {
					filteredCalendarData = currentCalendarData;
				}
				setCalendarData(filteredCalendarData);
				setLoading(false);
			})
			.catch(error => {
				console.error("Fetch Error:", error.message);
				setError(error.message);
				setLoading(false);
			});

	}

	if (error) return <div>Error: {error}</div>;

	if (requestedServiceCategory === 3 || requestedServiceCategory == 5 || requestedServiceCategory == 6) {
		return (
			<>
				<Filter
					selectedDate={selectedDate}
					setSelectedDate={setSelectedDate}
					setRequestedServiceCategory={(id) => setRequestedServiceCategory(id)}
					requestedServiceCategory={requestedServiceCategory}
				/>
				{
					!loading ?
						<div className="container">
							<div className="row">
								{calendarData && calendarData.map((program, index) => {
									let service_category_id = 3;
									let service_id = 0;
									let cal_date = new Date().toISOString().split("T")[0];
									let title = '';
									let serviceSubCategory = '';

									if (view === "program") {
										service_category_id = 3;
										service_id = program.gym_program_id;
										title = program.program_name;
									}
									if (view === "membership") {
										service_category_id = 5;
										title = program.membership_name;
										service_id = program.gym_membership_id;
									}
									if (view === "package") {
										service_category_id = 6;
										title = program.package_name;
										service_id = program.gym_package_id;
									}

									if (program.service_sub_category) {
										serviceSubCategory = program.service_sub_category?.service_sub_category_name || "";
									}

									return (
										<div key={index} className="col-12 col-md-6 mb-4">
											<ProgramCard
												image={program.gym_service_image && program.gym_service_image.length > 0 ? program.gym_service_image[0].image_path : defaultServiceImage}
												title={title}
												serviceSubCategory={serviceSubCategory}
												startDate={program.program_start_date}
												endDate={program.program_end_date}
												spotsBooked={program.booked_sessions}
												totalSpots={program.no_of_sessions}
												staff={program.gym_staff}
												gym_brand_id={gym_brand_id}
												brand_name={brand_name}
												gym_location_id={gym_location_id}
												requested_timezone_id={requested_timezone_id}
												category={service_category_id}
												service_id={service_id}
												cal_date={cal_date}
												service={program}
												idKey="gym_service_id"
												requestedServiceCategory={requestedServiceCategory}
												guestCheckoutUrl={guestCheckoutUrl}
											/>
										</div>
									);
								})}
							</div>
						</div> :
						<div>Loading...</div>
				}
			</>
		);
	}

	return (
		<div>
			{/* Calendar Icon */}
			<Filter
				selectedDate={selectedDate}
				setSelectedDate={setSelectedDate}
				setRequestedServiceCategory={(id) => setRequestedServiceCategory(id)}
				requestedServiceCategory={requestedServiceCategory}
			/>
			{
				!loading ?
					<div className="table-container" style={{ position: "relative" }}>
						<table className="schedule-table">
							<thead>
								<tr>
									<th width="9%">Time Slot</th>
									{weekDates.map(({ day, date }) => {
										return (
											<th width="10%" className="text-center" key={date}>
												{day} <br />({date})
											</th>
										);
									})}
								</tr>
							</thead>
							<tbody>
								{Array.from(
									new Set(
										calendarData && calendarData.map((service) => service.start_time)
									)
								)
									.sort()
									.map((startTime, rowIndex) => {
										const parsedTime = startTime ? DateTime.fromFormat(startTime, "HH:mm:ss") : null;
										const displayTime = parsedTime?.isValid
											? parsedTime.toFormat("hh:mm a")
											: "Invalid Time";

										return (
											<tr key={startTime}>
												{/* Time Slot Column */}
												<td
													className={`time-slot ${rowIndex % 2 === 0 ? "time-slot-dark" : ""}`}
												>
													{displayTime}
												</td>

												{/* Calendar Columns */}
												{weekDates.map(({ date: columnDate }) => {
													const servicesForDateAndTime = calendarData && calendarData.filter((service) => {
														const serviceDate = DateTime.fromISO(service.cal_date).toFormat("MM/dd/yyyy");
														return serviceDate === columnDate && service.start_time === startTime;
													});

													return (
														<td
															className={`${servicesForDateAndTime.length > 0 ? "training" : ""} ${rowIndex % 2 === 0 ? "time-slot-dark" : ""
																}`}
															key={columnDate}
														>
															{servicesForDateAndTime.length > 0
																? servicesForDateAndTime.map((service, index) => {
																	const category = service.service_category_id;

																	// Dynamic key logic
																	let nameKey = "";
																	let idKey = "";

																	if (category == 1) {
																		nameKey = "appointment_name";
																		idKey = "gym_appointment_id";
																	} else if (category == 2) {
																		nameKey = "class_name";
																		idKey = "gym_class_id";
																	} else if (category == 4) {
																		nameKey = "event_name";
																		idKey = "gym_event_id";
																	} else if (category == 3 || category == 5 || category == 6) {
																		nameKey = "service_name";
																		idKey = "gym_service_id";
																	}

																	const parsedStartTime = service.start_time ? DateTime.fromFormat(
																		service.start_time,
																		"HH:mm:ss"
																	).toFormat("hh:mm a") : null;

																	const parsedEndTime = service.end_time ? DateTime.fromFormat(
																		service.end_time,
																		"HH:mm:ss"
																	).toFormat("hh:mm a") : null;

																	const url = `https://${guestCheckoutUrl}.getphysio.biz/landing/landing-layout/guest-checkout?gym_brand_id=${gym_brand_id}&brand_name=${encodeURIComponent(
																		brand_name
																	)}&gym_location_id=${gym_location_id}&requested_timezone_id=${requested_timezone_id}&gym_service_category_id=${category}&gym_service_id=${service[idKey]
																		}&cal_date=${service.cal_date}&domain=${encodeURIComponent(redirect_url)}`;

																	return (
																		<div key={index}>
																			<a className="text" target="_blank" href={url}>
																				{service[nameKey]}
																			</a>{" "}
																			<br />
																			<p>
																				{parsedStartTime} - {parsedEndTime}
																			</p>
																			<p style={{ textAlign: "center" }}>
																				<a className="hyperlinkColor" href={url}>
																					Purchase
																				</a>
																			</p>
																		</div>
																	);
																})
																: ""}
														</td>
													);
												})}
											</tr>
										);
									}).filter(Boolean)}
							</tbody>
						</table>
					</div> :
					<div>Loading...</div>
			}
		</div>
	)
}

export default App;
